import { render } from "./PredictionList.vue?vue&type=template&id=4574752c&scoped=true"
import script from "./PredictionList.vue?vue&type=script&lang=js"
export * from "./PredictionList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4574752c"

export default script